import React from 'react'
import './Dashboard.scss'
import Navbar from '../../Components/Navbar/Navbar'
import Generate from '../../Components/Generate/Generate'
import Account from '../../Components/Account/Account'
import Plans from '../../Components/Plans/Plans'
import Usage from '../../Components/Usage/Usage'

function Dashboard() {
  return (
    <div className='background'>
      <Navbar 
      homeNav='navbar navbar-expand-md navbar-dark bg-custom'
      dashButton='Return Home'
      link="/"
      />

      <div className='dashboardGrid'>
        <Generate/>
        <Account/>
        <Plans/>
        <Usage/>
      </div>
    </div>
  )
}

export default Dashboard